<template>
  <b-input-group>
    <b-input
      :value="value"
      :type="valueIsVisible ? 'text' : 'password'"
      readonly/>
    <b-input-group-text
      v-if="hidden"
      slot="append"
      class="btn btn-main"
      @click="toggleVisibility">
      <span
        v-if="!valueIsVisible">
        <div
          v-if="showIcon"
          class="show-me" />
        <template v-else>
          Show
        </template>
      </span>
      <span v-else>
        <div
          v-if="hideIcon"
          class="hide-me" />
        <template v-else>
          Hide
        </template>
      </span>
    </b-input-group-text>
    <b-input-group-text
      slot="append"
      v-to-clipboard="value"
      class="btn btn-main"
      @copy="copyDone" >
      <span
        v-if="!iconButton && linkCopied"
        class="done">
        Copied!
      </span>
      <span
        v-else-if="!iconButton && linkError"
        class="error">
        Unable to copy :(
      </span>

      <span
        v-else-if="value" >
        <div
          v-if="iconButton"
          class="copy-me" />
        <template v-else>
          Copy
        </template>
      </span>
    </b-input-group-text>
  </b-input-group>
</template>

<script>
import ToasterMixin from '@/mixins/Toaster';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'CopyInput',
  components: {
    SBIcon,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    value: {
      type: String,
      default: '',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    iconButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      linkCopied: false,
      linkError: false,
      showHiddenItem: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    valueIsVisible() {
      return !this.hidden || (this.hidden && this.showHiddenItem);
    },
  },
  methods: {
    toggleVisibility() {
      this.showHiddenItem = !this.showHiddenItem;
    },
    copyDone(e) {
      if (e.detail) {
        this.linkCopied = true;
        this.showToaster('Copied to clipboard.', null, null, 'OK');
      } else {
        this.linkError = true;
      }
      setTimeout(() => {
        this.linkCopied = false;
        this.linkError = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
// .copy-me-wrapper {
  // position: absolute;
  // right: 5px;
  // width: 30px;
  // height: 20px;
  // background: rgb(255,255,255);
  // background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 43%, rgba(255,255,255,1) 100%);

  // .copy-me {
  //   // position: absolute;
  //   // right: 0;
  //   cursor: pointer;
  //   // margin: 4px 0 4px;
  //   display: block;
  //   width: 14px;
  //   height: 14px;
  //   background-image: url('~@/assets/img/SB-Icons/copy.svg');
  //   background-repeat: no-repeat;
  //   background-position: center;

  //   &:hover {
  //     background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
  //   }
  // }
// }
</style>

<style lang="scss" scoped>
::v-deep input[readonly]:focus {
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1) !important;
  border: 1px solid $greyBorder !important;
}

::v-deep input {
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1) !important;
}

::v-deep .input-group-text.btn {
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1) !important;
}

.btn {
  .copy-me {
    cursor: pointer;
    display: block;
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .copy-me {
    background-image: url('~@/assets/img/SB-Icons/copy.svg');
  }

  .show-me, .hide-me {
    cursor: pointer;
    display: block;
    width: 16px;
    height: 16px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #54626C;
  }

  .show-me {
    mask: url('~@/assets/img/SB-Icons/eye-open.svg') no-repeat center !important;
    mask-size: 16px 12px !important;
  }

  .hide-me {
    mask: url('~@/assets/img/SB-Icons/eye-closed.svg') no-repeat center !important;
    mask-size: 16px 14px !important;
  }

  &:hover {
    .copy-me {
      background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
    }

    .show-me, .hide-me {
      background-color: $blackPrimary;
    }
  }
}
</style>
